exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-message-banner .row {\n  max-width: 100%;\n  padding: 1.2em 5%;\n}\n", ""]);

// exports
